import { useMemo } from "react";

import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { StackSuggestions } from "constants/stack";
import { getCommitDigitsCount } from "utils/commit";

import StacksTableCommitCellContent from "./Content";
import useCellFilterAction from "../../useCellFilterAction";

const StacksTableCommitCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const commitHash = stack.trackedCommit?.hash.slice(0, getCommitDigitsCount(stack.provider));

  const commitFilterAction = useCellFilterAction({
    filterName: StackSuggestions.Commit,
    filterValue: commitHash || "",
  });

  const actions = useMemo(() => {
    if (commitHash) {
      return [commitFilterAction];
    }
    return undefined;
  }, [commitFilterAction, commitHash]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <StacksTableCommitCellContent stack={stack} />
    </TableSimpleCell>
  );
};

export default StacksTableCommitCell;
